/* istanbul ignore file */

import { Module } from 'vuex';
import { AppState } from '..';

import { prefixValues } from '@/helpers/util';
import { MonoMenuCacheObject, RecipeGroup } from '@/models';
import Vue from 'vue';

const MUTATION_NAMES = {
  CACHE_MONO_MENU: 'cacheMonoMenu',
  SET_RESIZE_LISTENER: 'setResizeListner',
  SET_RECIPE_GROUPS: 'setRecipeGroups'
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'monoMenu/');

export interface MonoMenuModuleState {
  monoMenuCache: {
    [index: string]: MonoMenuCacheObject;
  };
  resizeListener: (() => void) | undefined;
  recipeGroups: RecipeGroup[];
}

export function makeMonoMenuModule(): Module<MonoMenuModuleState, AppState> {
  return {
    namespaced: true,
    state: {
      monoMenuCache: {},
      resizeListener: undefined,
      recipeGroups: []
    },
    mutations: {
      [MUTATION_NAMES.CACHE_MONO_MENU](state, monoMenu: MonoMenuCacheObject) {
        Vue.set(state.monoMenuCache, monoMenu.key, monoMenu);
      },
      [MUTATION_NAMES.SET_RESIZE_LISTENER](state, listener: () => void) {
        state.resizeListener = listener;
      },
      [MUTATION_NAMES.SET_RECIPE_GROUPS](state, recipeGroups: RecipeGroup[]) {
        state.recipeGroups = recipeGroups;
      }
    },
  };
}
